<template>
  <div>
    <el-dialog
      :title="dialog.title"
      :width="dialog.width"
      :visible.sync="dialog.visible"
      :before-close="handleClose"
      :show-close="true"
    >
      <!-- 走马灯 -->
      <el-carousel
        :height="carousel.height"
        :initial-index="carousel.initialIndex"
        :trigger="carousel.trigger"
        :autoplay="carousel.autoplay"
        :interval="carousel.interval"
        :indicator-position="carousel.indicator"
        :arrow="carousel.arrow"
        :loop="true"
        @change="carouselChange"
      >
        <el-carousel-item
          v-for="(item, index) in carousel.data"
          :key="item.label || index"
          :name="item.name"
          :label="item.label"
        >
          <slot></slot>
        </el-carousel-item>
      </el-carousel>
      <!-- 按钮 -->
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancel">取 消</el-button>
        <el-button
          type="primary"
          @click="confirm"
        >确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object
    },
    carousel: {
      type: Object,
      default() {
        return {
          height: "150px"
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    // 确定
    confirm() {
      this.$emit("confirm");
      this.dialog.visible = false;
    },
    // 取消
    cancel() {
      this.dialog.visible = false;
    },
    // 关闭
    handleClose() {
      console.log("关闭了模态框");
    },
    // 幻灯片切换时触发
    carouselChange(index, oldIndex) {
      this.$emit("carouseChange", index, oldIndex);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
</style>
